/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useEffect, useMemo, useState } from "react";
import usePluginUtils from "../usePluginUtils";

export const usePaymentProcessorSelection = (
  paymentProcessors,
  disabledPayLater,
  { hideDelay = false, recurringOnly = false } = {}
) => {
  const { isPluginEnabled } = usePluginUtils();
  const [selectedProcessor, setSelectedProcessor] = useState(null);

  const filteredPaymentProcessors = useMemo(() => {
    return paymentProcessors?.filter((processor) => {
      if (recurringOnly && !processor.is_recurring_supported) {
        return false;
      }
      if (processor.id === "delay") {
        if (hideDelay) {
          return false;
        }
        if (isPluginEnabled("deposit_paid_events") && disabledPayLater) {
          return false;
        }
      }
      return true;
    });
  }, [paymentProcessors, isPluginEnabled, disabledPayLater, hideDelay, recurringOnly]);

  useEffect(() => {
    if (!filteredPaymentProcessors) return;
    if (filteredPaymentProcessors.length === 1) {
      setSelectedProcessor(filteredPaymentProcessors[0].id);
      return;
    }

    setSelectedProcessor((prev) => (prev && !filteredPaymentProcessors.some((p) => p.id === prev) ? null : prev));
  }, [filteredPaymentProcessors]);

  return { selectedProcessor, setSelectedProcessor, filteredPaymentProcessors };
};
